import { render, staticRenderFns } from "./DisplayHeader.vue?vue&type=template&id=15a79100&scoped=true"
import script from "./DisplayHeader.vue?vue&type=script&lang=js"
export * from "./DisplayHeader.vue?vue&type=script&lang=js"
import style0 from "./DisplayHeader.vue?vue&type=style&index=0&id=15a79100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a79100",
  null
  
)

export default component.exports